import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { MaterialModule } from '../material';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-selection-modal',
    templateUrl: './selection-modal.component.html',
    styleUrls: ['./selection-modal.component.scss'],
    imports: [MaterialModule,CommonModule,MatProgressSpinnerModule],
})
export class SelectionModalComponent implements OnInit {

  public title: string;
  private reset: boolean;
  @ViewChild('itmList', { static: true }) public itmList: MatSelectionList;
  constructor(public dialogRef: MatDialogRef<SelectionModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  public ngOnInit() {
    this.title = this.data.title;
  }

  public updateSelection() {
    this.dialogRef.close(this.itmList.selectedOptions.selected.map(itm => itm.value));
  }

  public resetSelection() {
    this.reset = this.reset ? false : true;
    if (this.reset) {
      this.itmList.deselectAll();
    }
  }

 public closeModal() {
  this.dialogRef.close();
}


}
